import React from 'react'
import { LoadingIndicator } from 'components/loading'

const Redirecting = (props) => {
  return <div><LoadingIndicator />Redirecting...</div>
}

export { 
  Redirecting
}
